import { createContext, useContext, ReactNode } from 'react';

export interface SSRStatusContext {
  notFound?: boolean;
}

const SSRContext = createContext<SSRStatusContext | null>(null);

export const SSRStatusProvider = ({
  children,
  value,
}: {
  children: ReactNode;
  value: SSRStatusContext;
}) => {
  return <SSRContext.Provider value={value}>{children}</SSRContext.Provider>;
};

export const useSSRStatus = (): SSRStatusContext | null => {
  return useContext(SSRContext);
};
